import { useContext } from 'react';
import { ConfigurationContext } from './ConfigurationContext.js';
export function useConfiguration() {
  const configuration = useContext(ConfigurationContext);
  if (!configuration || Object.keys(configuration).length === 0) {
    console.error('useConfiguration must be used within a ConfigurationContext.Provider');
  }
  return configuration;
}